(() => {
  const SELECTOR_CONTAINER = "[data-cart-upsells]";
  const SELECTOR_CARD = "[data-upsell-card]";
  const SELECTOR_LOAD_MORE = "[data-upsell-load-more]";

  function initContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    const pageSize = Math.max(1, parseInt(container.dataset.upsellPageSize || "5", 10) || 5);
    const cards = Array.from(container.querySelectorAll(SELECTOR_CARD));
    const loadMoreButton = container.querySelector(SELECTOR_LOAD_MORE);

    if (cards.length === 0) {
      if (loadMoreButton) loadMoreButton.closest(".cart-drawer-upsells__load-more")?.setAttribute("hidden", "");
      return;
    }

    let shown = Math.min(pageSize, cards.length);
    cards.forEach((card, index) => {
      if (index < shown) {
        card.removeAttribute("hidden");
      } else {
        card.setAttribute("hidden", "");
      }
    });

    const loadMoreWrap = loadMoreButton?.closest(".cart-drawer-upsells__load-more");
    if (loadMoreWrap) {
      if (shown >= cards.length) {
        loadMoreWrap.setAttribute("hidden", "");
      } else {
        loadMoreWrap.removeAttribute("hidden");
      }
    }

    if (container.dataset.upsellBound === "true") return;
    container.dataset.upsellBound = "true";

    container.addEventListener("click", (event) => {
      const target = event.target instanceof Element ? event.target.closest(SELECTOR_LOAD_MORE) : null;
      if (!target) return;

      event.preventDefault();

      const currentCards = Array.from(container.querySelectorAll(SELECTOR_CARD));
      let currentShown = currentCards.filter((c) => !c.hasAttribute("hidden")).length;
      const nextShown = Math.min(currentCards.length, currentShown + pageSize);

      currentCards.forEach((card, index) => {
        if (index < nextShown) card.removeAttribute("hidden");
      });

      const wrap = target.closest(".cart-drawer-upsells__load-more");
      if (wrap) {
        if (nextShown >= currentCards.length) {
          wrap.setAttribute("hidden", "");
        } else {
          wrap.removeAttribute("hidden");
        }
      }

      target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "end" });
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_CONTAINER).forEach(initContainer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("cart:change", initAll);
  document.addEventListener("cart:refresh", initAll);
})();

